import { usingGet } from '@ocean/api'

export const getVirtualEvents = () => usingGet('VirtualEvents/Events', { useProxy: true })
